// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Lookup } from './lookup';
import { MeetingAttendance } from './meeting-attendance';
import { MeetingResolution } from './meeting-resolution';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MeetingAttendanceResolution extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  meetingAttendanceResolutionId!: number;
  createdBy!: string;
  createdDate!: Date;
  meetingAttendanceId!: number;
  meetingResolutionId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  voteLookupId?: number;
  meetingAttendance!: MeetingAttendance;
  meetingResolution!: MeetingResolution;
  voteLookup!: Lookup;
}

